var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGkeEmptyIllustration = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 253,
    viewBox: "0 0 386 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203 146H144V253H203V146Z",
    fill: "#7871C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.746 146H205V207H369V158.519C352.97 176.602 329.566 188 303.5 188C271.84 188 244.108 171.186 228.746 146Z",
    fill: "#1B2473"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M369 209H205V253H369V209Z",
    fill: "#DF8981"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277 0H369V42.4813C352.97 24.3977 329.566 13 303.5 13C294.262 13 285.359 14.4315 277 17.0847V0Z",
    fill: "#7871C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144 0H275V17.7463C240.667 29.568 216 62.1533 216 100.5C216 116.334 220.206 131.187 227.562 144H144V0Z",
    fill: "#DF8981"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142 146H0V253H142V146Z",
    fill: "#1B2473"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142 0H0V144H142V0Z",
    fill: "#7871C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M247 40.3829C242.062 45.0259 237.695 50.2707 234.018 56H247V40.3829Z",
    fill: "#DF8981"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M221.252 94C222.305 80.4927 226.611 67.8984 233.387 57H247V94H221.252Z",
    fill: "#DF8981"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M229.995 138C224.244 126.749 221 114.003 221 100.5C221 98.6518 221.061 96.8179 221.18 95H247V138H229.995Z",
    fill: "#DF8981"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M270 25.085C277.184 21.8891 284.909 19.6895 293 18.6618V37H270V25.085Z",
    fill: "#DF8981"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M250.828 37C256.328 32.4326 262.431 28.5662 269 25.538V37H250.828Z",
    fill: "#DF8981"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M248 39.458C248.542 38.9648 249.091 38.4788 249.646 38H269V87H248V39.458Z",
    fill: "#DF8981"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M270 107H293V138H270V107Z",
    fill: "#DF8981"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M248 88H269V138H248V88Z",
    fill: "#DF8981"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M293 106H270V38H293V106Z",
    fill: "#DF8981"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M339 26.0074C328.247 20.8739 316.209 18 303.5 18C300.287 18 297.117 18.1836 294 18.541V36H339V26.0074Z",
    fill: "#7871C9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M384.349 117C382.846 124.409 380.349 131.457 377.004 138H371V117H384.349Z",
    fill: "#7871C9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M385.205 89C385.729 92.7582 386 96.5975 386 100.5C386 105.798 385.5 110.98 384.546 116H371V89H385.205Z",
    fill: "#7871C9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M371 53.0542C378.176 63.2452 383.103 75.1345 385.059 88H371V53.0542Z",
    fill: "#7871C9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M340 26.4931C350.918 31.8884 360.471 39.6287 368 49.0561V56H340V26.4931Z",
    fill: "#7871C9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M294 37H339V90H294V37Z",
    fill: "#7871C9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M370 101H340V138H370V101Z",
    fill: "#7871C9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M370 57H340V100H370V57Z",
    fill: "#7871C9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M294 91H339V138H294V91Z",
    fill: "#7871C9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M241.563 155C237.284 150.14 233.567 144.773 230.516 139H282V155H241.563Z",
    fill: "#1B2473"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M250.828 164C247.855 161.531 245.058 158.857 242.458 156H282V164H250.828Z",
    fill: "#1B2473"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M282 180.17C270.924 177.189 260.769 171.959 252.056 165H282V180.17Z",
    fill: "#1B2473"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M317 181.901C312.607 182.624 308.098 183 303.5 183C296.423 183 289.555 182.109 283 180.433V165H317V181.901Z",
    fill: "#1B2473"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M349.494 169C342.266 173.862 334.228 177.611 325.624 180H318V169H349.494Z",
    fill: "#1B2473"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M363.617 157C359.782 161.079 355.536 164.768 350.946 168H318V157H363.617Z",
    fill: "#1B2473"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M376.485 139C373.222 145.172 369.2 150.88 364.542 156H318V139L376.485 139Z",
    fill: "#1B2473"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M317 139H283V164H317V139Z",
    fill: "#1B2473"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGkeEmptyIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GKE-empty-illustration.312045a80ac5175dd085d370f2dc2c42.svg";